import type { ApiRequest } from "@/api/types";
import { httpAuth2 } from "@/api/auth";

export type UnreadMessageCountResponse = {
  unread_count: number;
};

type MessagingRequestsTyped = {
  fetch_unread_message_count: ApiRequest<UnreadMessageCountResponse>;
};

export const messagingRequestsTyped: MessagingRequestsTyped = {
  fetch_unread_message_count: function ({ context } = {}) {
    return httpAuth2
      .post("/v1/messaging/unread_message_count", { context })
      .json<UnreadMessageCountResponse>();
  },
};
